// extracted by mini-css-extract-plugin
export default {"sectionMain":"SectionMain_sectionMain__0qGM8","container":"SectionMain_container__wHIow","description":"SectionMain_description__RVNLC"};